(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grivet-flash-sale"] && !Shopify.designMode) return;
  try {
    
  class GrivetCountdown extends HTMLElement {
    connectedCallback() {
      const end = Date.parse(this.dataset.end);
      if (isNaN(end)) return;
      this.els = {
        days: this.querySelector('[data-days]'),
        hours: this.querySelector('[data-hours]'),
        minutes: this.querySelector('[data-minutes]'),
        seconds: this.querySelector('[data-seconds]')
      };
      const tick = () => {
        const diff = end - Date.now();
        if (diff <= 0) {
          if (this.els.days) this.els.days.textContent = '0';
          if (this.els.hours) this.els.hours.textContent = '00';
          if (this.els.minutes) this.els.minutes.textContent = '00';
          if (this.els.seconds) this.els.seconds.textContent = '00';
          clearInterval(this._i);
          return;
        }
        const s = Math.floor(diff / 1000);
        const days = Math.floor(s / 86400);
        const hours = Math.floor((s % 86400) / 3600);
        const minutes = Math.floor((s % 3600) / 60);
        const seconds = s % 60;
        if (this.els.days) this.els.days.textContent = days;
        if (this.els.hours) this.els.hours.textContent = String(hours).padStart(2, '0');
        if (this.els.minutes) this.els.minutes.textContent = String(minutes).padStart(2, '0');
        if (this.els.seconds) this.els.seconds.textContent = String(seconds).padStart(2, '0');
      };
      tick();
      this._i = setInterval(tick, 1000);
    }
    disconnectedCallback() { clearInterval(this._i); }
  }
  if (!customElements.get('grivet-countdown')) {
    customElements.define('grivet-countdown', GrivetCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grivet-quiz-takeover"] && !Shopify.designMode) return;
  try {
    
(function () {
  const root = document.querySelector('[data-quiz-takeover]');
  if (!root) return;
  const cookieName = root.dataset.cookie;
  const delay = Number(root.dataset.delay) * 1000 || 18000;

  function has(name) { return document.cookie.split(';').some(c => c.trim().startsWith(name + '=')); }
  function set(name, val, days) {
    const exp = new Date(Date.now() + days * 86400000).toUTCString();
    document.cookie = `${name}=${val}; expires=${exp}; path=/; SameSite=Lax`;
  }
  // Skip if already dismissed, if session already has quiz state, or if user scrolled past the hero
  if (has(cookieName)) return;
  if (sessionStorage.getItem('grivet_quiz_state_v1')) return;

  let lastFocused = null;
  let openTimer = setTimeout(openModal, delay);

  function openModal() {
    lastFocused = document.activeElement;
    root.hidden = false;
    document.body.style.overflow = 'hidden';
    const cta = root.querySelector('.gqt-cta');
    if (cta) cta.focus();
    root.addEventListener('keydown', trapFocus);
  }
  function closeModal() {
    root.hidden = true;
    document.body.style.overflow = '';
    set(cookieName, '1', 30);
    root.removeEventListener('keydown', trapFocus);
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }
  function trapFocus(e) {
    if (e.key === 'Escape') { e.preventDefault(); closeModal(); return; }
    if (e.key !== 'Tab') return;
    const focusables = root.querySelectorAll('button, a');
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  root.addEventListener('click', (e) => {
    if (e.target.closest('[data-gqt-close]')) { e.preventDefault(); clearTimeout(openTimer); closeModal(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grivet-shoe-finder"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const roots = document.querySelectorAll('[data-quiz]');
    roots.forEach(initQuiz);

    function initQuiz(root) {
      const form = root.querySelector('[data-quiz-form]');
      const steps = root.querySelectorAll('.gh-quiz-step');
      const nextBtn = root.querySelector('[data-next]');
      const prevBtn = root.querySelector('[data-prev]');
      const submitBtn = root.querySelector('[data-submit]');
      const progressBar = root.querySelector('[data-progress-bar]');
      const progressCurrent = root.querySelector('[data-progress-current]');
      const progressTotal = root.querySelector('[data-progress-total]');
      const restartBtn = root.querySelector('[data-restart]');
      const results = root.querySelector('[data-results]');
      const resultCards = root.querySelector('[data-results-cards]');
      const resultHeading = root.querySelector('[data-results-heading]');
      const resultSub = root.querySelector('[data-results-sub]');
      const buckets = root.querySelectorAll('[data-bucket]');

      let current = 1;
      const total = steps.length;
      progressTotal.textContent = total;

      function showStep(n) {
        steps.forEach((s, i) => s.classList.toggle('is-active', i === n - 1));
        progressCurrent.textContent = n;
        progressBar.style.setProperty('--gh-progress', (n / total * 100) + '%');
        prevBtn.hidden = n === 1;
        nextBtn.hidden = n === total;
        submitBtn.hidden = n !== total;
      }

      function stepAnswered(n) {
        const step = steps[n - 1];
        return !!step.querySelector('input[type="radio"]:checked');
      }

      nextBtn.addEventListener('click', () => {
        if (!stepAnswered(current)) {
          steps[current - 1].querySelector('.gh-quiz-opt').focus();
          return;
        }
        if (current < total) { current++; showStep(current); }
      });
      prevBtn.addEventListener('click', () => {
        if (current > 1) { current--; showStep(current); }
      });

      // Auto-advance on answer (delight)
      form.addEventListener('change', (e) => {
        if (e.target.type !== 'radio') return;
        if (current < total) {
          setTimeout(() => { current++; showStep(current); }, 220);
        }
      });

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (!stepAnswered(total)) return;

        const data = new FormData(form);
        const answers = {
          terrain: data.get('terrain'),
          cushion: data.get('cushion'),
          stability: data.get('stability'),
          gender: data.get('gender')
        };

        const bucketKey = deriveBucketKey(answers);
        const bucketEl = Array.from(buckets).find(b => b.dataset.bucket === bucketKey);

        let handles = [];
        let heading = 'Here are your matches.';
        let sub = '';

        if (bucketEl) {
          const handleStr = answers.gender === 'women' ? bucketEl.dataset.women : bucketEl.dataset.men;
          handles = handleStr.split(',').map(h => h.trim()).filter(Boolean);
          if (bucketEl.dataset.title) heading = bucketEl.dataset.title;
          if (bucketEl.dataset.desc) sub = bucketEl.dataset.desc;
        }

        resultHeading.textContent = heading;
        resultSub.textContent = sub;
        resultCards.innerHTML = '';

        form.hidden = true;
        root.querySelector('[data-progress]').hidden = true;
        results.hidden = false;
        results.scrollIntoView({ behavior: 'smooth', block: 'start' });

        if (!handles.length) {
          resultCards.innerHTML = '<div class="gh-quiz-card-empty">We couldn\u2019t find a perfect match — try the retake or browse all running shoes below.</div>';
          return;
        }

        // Fetch product data via Shopify's product JSON endpoint
        const fetched = await Promise.all(handles.slice(0, 3).map(fetchProduct));
        fetched.filter(Boolean).forEach(p => resultCards.appendChild(buildCard(p)));
        if (!resultCards.children.length) {
          resultCards.innerHTML = '<div class="gh-quiz-card-empty">We couldn\u2019t load those shoes right now. Browse all running shoes below.</div>';
        }
      });

      restartBtn.addEventListener('click', () => {
        form.reset();
        form.hidden = false;
        root.querySelector('[data-progress]').hidden = false;
        results.hidden = true;
        current = 1;
        showStep(current);
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      function deriveBucketKey(a) {
        if (a.terrain === 'trail' || a.terrain === 'both') return 'trail';
        if (a.stability === 'yes') return 'stability';
        if (a.cushion === 'max') return 'cushion';
        if (a.cushion === 'responsive') return 'responsive';
        return 'daily';
      }

      async function fetchProduct(handle) {
        try {
          const res = await fetch('/products/' + handle + '.js');
          if (!res.ok) return null;
          return await res.json();
        } catch { return null; }
      }

      function buildCard(p) {
        const a = document.createElement('a');
        a.href = p.url;
        a.className = 'gh-quiz-card';
        const img = p.featured_image || (p.images && p.images[0]) || '';
        const price = (p.price / 100).toLocaleString('en-US', { style: 'currency', currency: window.Shopify && Shopify.currency && Shopify.currency.active || 'USD' });
        a.innerHTML =
          '<div class="gh-quiz-card-img">' + (img ? '<img src="' + img + '" alt="' + (p.title || '') + '" loading="lazy">' : '') + '</div>' +
          (p.vendor ? '<div class="gh-quiz-card-brand">' + p.vendor + '</div>' : '') +
          '<div class="gh-quiz-card-name">' + p.title + '</div>' +
          '<div class="gh-quiz-card-price">' + price + '</div>';
        return a;
      }

      showStep(1);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vip-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var KLAVIYO_COMPANY_ID = 'YxNnuy';
  var KLAVIYO_LIST_ID = 'TPsgGg';
  var forms = document.querySelectorAll('form[data-vip-newsletter]');
  forms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.querySelector('input[name="email"]').value.trim();
      var msg = form.parentElement.querySelector('[data-vip-newsletter-msg]');
      if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        if (msg) { msg.textContent = 'Please enter a valid email.'; msg.dataset.state = 'error'; }
        return;
      }
      var btn = form.querySelector('button');
      btn.disabled = true; btn.textContent = 'Signing up…';
      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Footer Newsletter',
            profile: { data: { type: 'profile', attributes: {
              email: email,
              subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
            } } }
          },
          relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } }
        }
      };
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-04-15' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (r.ok || r.status === 202) {
          form.style.display = 'none';
          if (msg) { msg.textContent = "You're in. Check your inbox for a welcome note."; msg.dataset.state = 'ok'; }
        } else {
          btn.disabled = false; btn.textContent = 'Sign up';
          if (msg) { msg.textContent = 'Something went wrong. Try again shortly.'; msg.dataset.state = 'error'; }
        }
      }).catch(function () {
        btn.disabled = false; btn.textContent = 'Sign up';
        if (msg) { msg.textContent = 'Network error. Try again shortly.'; msg.dataset.state = 'error'; }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vip-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  var toggle = document.querySelector('.v-mobile-toggle');
  var drawer = document.getElementById('vip-mobile-drawer');
  if (!toggle || !drawer) return;
  function open() { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); toggle.setAttribute('aria-expanded','true'); document.documentElement.classList.add('v-mobile-locked'); }
  function close() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); toggle.setAttribute('aria-expanded','false'); document.documentElement.classList.remove('v-mobile-locked'); }
  toggle.addEventListener('click', open);
  drawer.addEventListener('click', function(e){ if (e.target.hasAttribute('data-close')) close(); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vip-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Hide .v-pdp-rating-row when BV reports 0 reviews. Mirror of the collection-card logic.
  function detectCount(el) {
    var countEl = el.querySelector('[class*="numReviews"], [class*="num-reviews"], [class*="review_count"], [class*="reviewcount"]');
    if (countEl) {
      var m = (countEl.textContent || '').match(/\d+/);
      if (m) return parseInt(m[0], 10);
    }
    var arias = el.querySelectorAll('[aria-label*="review" i], [aria-label*="rating" i]');
    for (var i = 0; i < arias.length; i++) {
      var label = arias[i].getAttribute('aria-label') || '';
      var m2 = label.match(/(\d+)\s*reviews?/i) || label.match(/based on\s*(\d+)/i);
      if (m2) return parseInt(m2[1], 10);
      if (/no reviews/i.test(label)) return 0;
    }
    var text = (el.textContent || '').trim();
    var m3 = text.match(/\((\d+)\)/) || text.match(/(\d+)\s*reviews?/i);
    if (m3) return parseInt(m3[1], 10);
    if (/no reviews/i.test(text)) return 0;
    return null;
  }
  function processRatingRow(el) {
    if (el.dataset.vpdpReviewsProcessed) return;
    var count = detectCount(el);
    if (count === null) return;
    el.dataset.vpdpReviewsProcessed = '1';
    if (count > 0) el.classList.add('v-has-reviews');
  }
  function scanPdpRating() { document.querySelectorAll('.v-pdp-rating-row').forEach(processRatingRow); }
  var pdpInterval = setInterval(scanPdpRating, 400);
  setTimeout(function() { clearInterval(pdpInterval); scanPdpRating(); }, 25000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scanPdpRating);
  else scanPdpRating();
})();

(function () {
  'use strict';

  // Rating row: BV renders its own widget; CSS reshapes it.

  // Image gallery: thumbs open lightbox; paginated "+N more" overlay reveals more
  var mainImg = document.getElementById('vip-pdp-main-image');

  // Aspect-ratio-aware zoom: landscape products (shoes) get scale 1.3,
  // portrait/square products (backpacks, jackets) stay at scale 1.
  function applyAspectZoom(img) {
    if (!img || !img.naturalWidth || !img.naturalHeight) return;
    var ratio = img.naturalWidth / img.naturalHeight;
    img.classList.toggle('is-landscape', ratio > 1.15);
  }
  if (mainImg) {
    if (mainImg.complete) applyAspectZoom(mainImg);
    mainImg.addEventListener('load', function () { applyAspectZoom(mainImg); });
  }
  function openLightbox(src) {
    if (!src) return;
    var box = document.createElement('div');
    box.className = 'v-pdp-lightbox';
    box.innerHTML = '<button type="button" class="v-pdp-lightbox-close" aria-label="Close">&times;</button><img src="' + src + '" alt="">';
    document.documentElement.classList.add('v-pdp-no-scroll');
    document.body.classList.add('v-pdp-no-scroll');
    function close() {
      box.remove();
      document.documentElement.classList.remove('v-pdp-no-scroll');
      document.body.classList.remove('v-pdp-no-scroll');
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    box.addEventListener('click', function (e) {
      if (e.target === box || e.target.classList.contains('v-pdp-lightbox-close')) close();
    });
    document.addEventListener('keydown', onKey);
    document.body.appendChild(box);
  }
  var grid = document.querySelector('[data-vip-grid]');
  if (grid) {
    var thumbs = Array.prototype.slice.call(grid.querySelectorAll('[data-vip-thumb]'));
    var INITIAL = 4, STEP = 6;
    var visible = Math.min(INITIAL, thumbs.length);
    var mobileMql = window.matchMedia('(max-width: 1000px)');

    function applyVisibility() {
      // On mobile the grid is a horizontal scroll strip â€” show all thumbs, no overlay.
      if (mobileMql.matches) {
        thumbs.forEach(function (t) {
          var existing = t.querySelector('.v-pdp-view-all-overlay');
          if (existing) existing.remove();
          t.classList.remove('v-pdp-view-all');
          t.removeAttribute('data-vip-view-all');
          t.removeAttribute('hidden');
        });
        return;
      }
      thumbs.forEach(function (t, i) {
        var existing = t.querySelector('.v-pdp-view-all-overlay');
        if (existing) existing.remove();
        t.classList.remove('v-pdp-view-all');
        t.removeAttribute('data-vip-view-all');
        if (i < visible) { t.removeAttribute('hidden'); } else { t.setAttribute('hidden', ''); }
      });
      var remaining = thumbs.length - visible;
      if (remaining > 0 && visible > 0) {
        var last = thumbs[visible - 1];
        last.classList.add('v-pdp-view-all');
        last.setAttribute('data-vip-view-all', '');
        var overlay = document.createElement('div');
        overlay.className = 'v-pdp-view-all-overlay';
        overlay.innerHTML = '<span class="v-pdp-count">+' + remaining + '</span><span class="v-pdp-label">more</span>';
        last.appendChild(overlay);
      }
    }
    applyVisibility();
    mobileMql.addEventListener('change', applyVisibility);

    thumbs.forEach(function (t) {
      t.addEventListener('click', function (e) {
        if (t.hasAttribute('data-vip-view-all')) {
          // Reveal the next STEP thumbs in the current color-filtered view.
          // If more remain hidden, move the "+N more" overlay to the new last
          // visible thumb; otherwise drop the overlay entirely.
          e.preventDefault();
          e.stopPropagation();
          var eligible = thumbs.filter(function (tt) {
            return !tt.classList.contains('v-thumb-color-hidden');
          });
          var hiddenOverflow = eligible.filter(function (tt) {
            return tt.classList.contains('v-thumb-overflow-hidden');
          });
          var revealCount = Math.min(STEP, hiddenOverflow.length);
          hiddenOverflow.slice(0, revealCount).forEach(function (tt) {
            tt.classList.remove('v-thumb-overflow-hidden');
          });
          var ov = t.querySelector('.v-pdp-view-all-overlay');
          if (ov) ov.remove();
          t.classList.remove('v-pdp-view-all');
          t.removeAttribute('data-vip-view-all');
          var stillHidden = hiddenOverflow.length - revealCount;
          if (stillHidden > 0) {
            var nowVisible = eligible.filter(function (tt) {
              return !tt.classList.contains('v-thumb-overflow-hidden');
            });
            var newTrigger = nowVisible[nowVisible.length - 1];
            if (newTrigger) {
              var newOverlay = document.createElement('div');
              newOverlay.className = 'v-pdp-view-all-overlay';
              newOverlay.innerHTML = '<span class="v-pdp-count">+' + stillHidden + '</span><span class="v-pdp-label">more</span>';
              newTrigger.appendChild(newOverlay);
              newTrigger.classList.add('v-pdp-view-all');
              newTrigger.setAttribute('data-vip-view-all', '');
            }
          }
          return;
        }
        openLightbox(t.getAttribute('data-full'));
      });
    });
  }
  if (mainImg) {
    mainImg.style.cursor = 'zoom-in';
    mainImg.addEventListener('click', function () { openLightbox(mainImg.src); });
  }

  // Tabs
  document.querySelectorAll('[data-vip-tab]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.getAttribute('data-vip-tab');
      document.querySelectorAll('[data-vip-tab]').forEach(function (b) { b.classList.toggle('v-active', b === btn); });
      document.querySelectorAll('[data-vip-tab-panel]').forEach(function (p) {
        var on = p.getAttribute('data-vip-tab-panel') === key;
        p.classList.toggle('v-active', on);
        p.hidden = !on;
      });
    });
  });

  // Variant sync: click buttons -> update hidden id + selected class + CTA
  var variants = [], options = [];
  try {
    var dataEl = document.getElementById('vip-pdp-data');
    if (dataEl) {
      var parsed = JSON.parse(dataEl.textContent);
      variants = parsed.variants || [];
      options = parsed.options || [];
    }
  } catch (e) { console.error('[VIP PDP] data parse failed', e); }
  var selection = {};

  function initVariantSync() {
    var form = document.getElementById('vip-pdp-form');
    if (!form) return;
    var hidden = document.getElementById('vip-pdp-vid');
    var priceRow = document.querySelector('.v-pdp-price-row');
    // Seed selection from whichever button starts with .v-selected
    form.querySelectorAll('[data-vip-opt].v-selected').forEach(function (btn) {
      var n = btn.getAttribute('data-opt-name');
      var val = btn.getAttribute('data-opt-value');
      if (n) selection[n] = val;
    });

    function findVariant() {
      return variants.find(function (v) {
        return options.every(function (name, i) { return v.options[i] === selection[name]; });
      });
    }
    function refresh() {
      form.querySelectorAll('[data-vip-opt]').forEach(function (btn) {
        var n = btn.getAttribute('data-opt-name');
        var val = btn.getAttribute('data-opt-value');
        btn.classList.toggle('v-selected', selection[n] === val);
      });
      form.querySelectorAll('.v-pdp-size-opt').forEach(function (btn) {
        var sizeName = btn.getAttribute('data-opt-name');
        var sizeVal = btn.getAttribute('data-opt-value');
        var available = variants.some(function (v) {
          if (!v.available) return false;
          return options.every(function (name, i) {
            if (name === sizeName) return v.options[i] === sizeVal;
            if (selection[name] != null) return v.options[i] === selection[name];
            return true;
          });
        });
        btn.classList.toggle('v-oos', !available);
      });
      form.querySelectorAll('.v-pdp-color-opt').forEach(function (btn) {
        var colorName = btn.getAttribute('data-opt-name');
        var colorVal = btn.getAttribute('data-opt-value');
        var available = variants.some(function (v) {
          if (!v.available) return false;
          return options.every(function (name, i) {
            if (name === colorName) return v.options[i] === colorVal;
            if (selection[name] != null) return v.options[i] === selection[name];
            return true;
          });
        });
        btn.classList.toggle('v-oos', !available);
      });
      form.querySelectorAll('.v-pdp-option-block').forEach(function (block) {
        var label = block.querySelector('.v-pdp-option-label strong');
        var cur = block.querySelector('.v-pdp-current');
        if (label && cur) {
          var name = (label.textContent || '').trim();
          if (selection[name] != null) cur.textContent = selection[name];
        }
      });
      var v = findVariant();
      if (v && priceRow) {
        var priceHtml = '$' + (v.price / 100).toFixed(2);
        if (v.compare_at_price > v.price) {
          priceHtml += '<span class="v-pdp-old">$' + (v.compare_at_price / 100).toFixed(2) + '</span>';
        }
        if (v.price >= 6000) {
          priceHtml += '<span class="v-pdp-save">Free shipping</span>';
        }
        priceRow.innerHTML = priceHtml;
      }
      if (v && hidden) hidden.value = v.id;
      if (v && v.featured_image && v.featured_image.src && mainImg) {
        mainImg.src = v.featured_image.src;
      } else if (mainImg) {
        // No exact (color, size, ...) match â€” still swap hero to a variant with the selected color
        // so the customer sees what that color looks like even if their size is OOS in it.
        var colorName = null, colorVal = null;
        for (var k in selection) {
          var kl = k.toLowerCase();
          if (kl === 'color' || kl === 'colour') { colorName = k; colorVal = selection[k]; break; }
        }
        if (colorVal) {
          var colorIdx = options.indexOf(colorName);
          var firstInColor = variants.find(function (vv) {
            return colorIdx >= 0 && vv.options[colorIdx] === colorVal && vv.featured_image && vv.featured_image.src;
          });
          if (firstInColor) mainImg.src = firstInColor.featured_image.src;
        }
      }
      // Filter thumbnail strip by selected color, then cap at 6 visible
      // with a "+N more" reveal button. This is the single pagination
      // authority on the PDP â€” overrides the older applyVisibility logic.
      (function filterThumbsByColor() {
        var INITIAL = 6;
        var selColor = null;
        for (var k in selection) {
          var kl = k.toLowerCase();
          if (kl === 'color' || kl === 'colour') { selColor = (selection[k] || '').toLowerCase().trim(); break; }
        }
        var gridEl = document.querySelector('[data-vip-grid]');
        if (!gridEl) return;
        var colorMap = {};
        try {
          var raw = gridEl.getAttribute('data-image-color-map') || '';
          if (raw) colorMap = JSON.parse(raw);
        } catch (e) { colorMap = {}; }
        var thumbs = Array.prototype.slice.call(gridEl.querySelectorAll('[data-vip-thumb]'));

        // Reset every thumb to a clean state
        thumbs.forEach(function (t) {
          t.removeAttribute('hidden');
          t.removeAttribute('data-vip-view-all');
          t.classList.remove('v-pdp-view-all', 'v-thumb-color-hidden', 'v-thumb-overflow-hidden');
          var ov = t.querySelector('.v-pdp-view-all-overlay');
          if (ov) ov.remove();
        });

        // Pass 1: split into color-matches vs. non-matches
        var matches = [];
        thumbs.forEach(function (t) {
          var imgId = t.getAttribute('data-image-id') || '';
          var tColor = (colorMap[imgId] || '').toLowerCase().trim();
          var ok = !selColor || !tColor || tColor === 'unclear' || tColor === selColor;
          if (ok) matches.push(t);
          else t.classList.add('v-thumb-color-hidden');
        });

        // Pass 2: cap matches at INITIAL; hide the rest behind a "+N more" overlay
        if (matches.length > INITIAL) {
          matches.slice(INITIAL).forEach(function (t) { t.classList.add('v-thumb-overflow-hidden'); });
          var trigger = matches[INITIAL - 1];
          var remaining = matches.length - INITIAL;
          var overlay = document.createElement('div');
          overlay.className = 'v-pdp-view-all-overlay';
          overlay.innerHTML = '<span class="v-pdp-count">+' + remaining + '</span><span class="v-pdp-label">more</span>';
          trigger.appendChild(overlay);
          trigger.classList.add('v-pdp-view-all');
          trigger.setAttribute('data-vip-view-all', '');
        }
      })();
      var cta = form.querySelector('button[type="submit"]');
      if (cta) {
        if (v && v.available) {
          cta.disabled = false;
          cta.textContent = 'Add to cart';
        } else {
          cta.disabled = true;
          cta.textContent = 'Sold out';
        }
      }
    }

    var swatchBtns = form.querySelectorAll('[data-vip-opt]');
    console.log('[VIP PDP] init â€” form:', !!form, 'swatch buttons:', swatchBtns.length);
    swatchBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (btn.disabled) return;
        e.preventDefault();
        e.stopPropagation();
        var n = btn.getAttribute('data-opt-name');
        var val = btn.getAttribute('data-opt-value');
        if (!n) return;
        selection[n] = val;
        // If user clicked a SIZE and the resulting combo is OOS,
        // auto-switch color (and other options) to an available variant that has this size.
        if (btn.classList.contains('v-pdp-size-opt')) {
          var match = findVariant();
          if (!match || !match.available) {
            var nIdx = options.indexOf(n);
            var fallback = null, bestScore = -1;
            variants.forEach(function (v) {
              if (!v.available) return;
              if (nIdx < 0 || v.options[nIdx] !== val) return;
              var score = 0;
              options.forEach(function (name, i) {
                if (name === n) return;
                var nl = name.toLowerCase();
                if (nl === 'color' || nl === 'colour') return;
                if (v.options[i] === selection[name]) score += 1;
              });
              if (score > bestScore) { bestScore = score; fallback = v; }
            });
            if (fallback) {
              options.forEach(function (name, i) { selection[name] = fallback.options[i]; });
            }
          }
        }
        refresh();
      });
    });
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantSync);
  } else {
    initVariantSync();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
